import React from 'react'
import NextIcon from "../../assets/images/nextIcon.svg"

const NextButton = () => {
  return (
    <div>
        <div style={{
        background: "#444649",
        width:"20px",
        height:"20px",
        borderRadius:"6px",
        display:"flex",
        alignItems:"center",
        justifyContent:"center"


    }}>
        <img src={NextIcon} alt='next' width="7px"/>
    </div>
    </div>
  )
}

export default NextButton